export * from './mesCommandesMixedUxCore.js';

import { getProductImageUrl } from './productImage.js';
import { getFirstProductLine } from './mesCommandesMixedUxCore.js';

/** Vignette produit (Cloudinary / chemins relatifs via Vite). */
export function resolveCommandeProductThumbUrl(commande) {
  const first = getFirstProductLine(commande);
  const produit = first?.produit || first;
  return getProductImageUrl(produit, { width: 96 });
}

/** Vignette prestation (liste admin sans images → souvent null). */
export function resolvePrestationThumbUrl(commande) {
  return getProductImageUrl(commande?.prestation, { width: 96 });
}
